import React from 'react'

import {
  BrowserRouter,
  Routes,
  Route,
} from 'react-router-dom'
import MerchantsPage from './pages/Merchants/MerchantsPage'
import MerchantDetailsPage from './pages/Merchants/MerchantDetailsPage'
import POSIntegrationPage from './pages/POSIntegration/POSIntegrationPage'
import UserManagement from './pages/UserManagement/UserManagement'
import DashboardLayout from './layouts/DashboardLayout/DashboardLayout'

import AuthPage from './pages/Auth/Auth'
import Dashboard from './pages/Dashboard/Dashboard'
import ReportAnalytics from './pages/ReportAnalytics/ReportAnalyticsPage'
import ProfilePage from './pages/Profile/ProfilePage'
import ProtectedRoute from './routes/ProtectedRoute'
import Error404 from './pages/utility/Error404'
import NotAuthorized from './pages/utility/NotAuthorized'
import ConfigSettingPage from './pages/ConfigSetting/ConfigSettingPage'
// import VouchersPage from './pages/CampaignLinks/CampaignLinksPage'

function App() {
  return (
    <BrowserRouter>
      <Routes>
        
        <Route
          path="/login"
          element={<AuthPage />}
        />

        <Route element={<ProtectedRoute><DashboardLayout /></ProtectedRoute>}>
          <Route
            path="/"
            element={<Dashboard />}
          />
          <Route
            path="/merchants"
            element={<MerchantsPage />}
          />
          <Route
            path="/merchants/:id"
            element={<MerchantDetailsPage />}
          />
          <Route
            path="/pos-integrations"
            element={<POSIntegrationPage />}
          />
          <Route
            path="/reports-analytics"
            element={<ReportAnalytics />}
          />
          <Route
            path="/user-management"
            element={<UserManagement />} 
          />
          <Route
            path="/profile"
            element={<ProfilePage />}
          />
          <Route
            path="/config-settings"
            element={<ConfigSettingPage />}
          />
        </Route>
        <Route path="*" element={<Error404 />} />
        <Route path="/unauthorized" element={<NotAuthorized />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App
